import { create } from "zustand";
export const useDialogStore = create((set)=>({
        dialogs: {},
        open: (payload)=>{
            set((state)=>{
                let newDialog;
                if (payload.type === "confirm") {
                    newDialog = {
                        id: payload.id,
                        type: "confirm",
                        props: {
                            ...payload.props,
                            open: true
                        }
                    };
                } else {
                    newDialog = {
                        id: payload.id,
                        type: "custom",
                        props: {
                            ...payload.props,
                            open: true
                        }
                    };
                }
                return {
                    dialogs: {
                        ...state.dialogs,
                        [payload.id]: newDialog
                    }
                };
            });
        },
        close: (id)=>{
            set((state)=>{
                // 존재하지 않는 ID면 동일 state 반환 → 불필요한 리렌더 방지
                if (!(id in state.dialogs)) return state;
                const { [id]: _ , ...rest } = state.dialogs;
                return {
                    dialogs: rest
                };
            });
        }
    }));
